/**
 * Retrieves the current experience based on the URL.
 * If the URL is in the format "/{currentApplication}/...", the current application is extracted.
 * Otherwise, it returns 'HomePage'.
 * @returns The current experience or 'HomePage' if not found.
 */
export const getCurrentExperience = () => {
    try {
        const href = window.location.href;
        const url = href.substring(href.indexOf('/#/') + 3); // Extract part after /#/
        const segments = url.split('/'); // Split by /
        const currentApplication = segments[0]; // Get the first segment
        return currentApplication || 'celine'; // Return 'HomePage' if empty
    }
    catch (error) {
        console.error('Error extracting current application:', error);
        return 'celine'; // Return 'HomePage' in case of an error
    }
};
export const getApp = () => {
    try {
        const href = window.location.href;
        const url = href.substring(href.indexOf('/#/') + 3); // Extract part after /#/
        const segments = url.split('/'); // Split by /
        const currentApplication = segments[0]; // Get the first segment
        return currentApplication || 'celine'; // Return 'HomePage' if empty
    }
    catch (error) {
        console.error('Error extracting current application:', error);
        return 'celine'; // Return 'HomePage' in case of an error
    }
};
export const getActiveExperienceFromCeline = () => {
    try {
        if ('__CELINE_activeExp' in window) {
            return window['__CELINE_activeExp'];
        }
        else if ('celineTargetCE' in window) {
            return window['celineTargetCE'];
        }
        else {
            return 'celine';
        }
    }
    catch (error) {
        console.error('Error extracting current application:', error);
        return 'Unknown'; // Return 'Unknown' in case of an error
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/experience.utils.js
// module id = ./node_modules/@celine/passive-tracking/dist/experience.utils.js
// module chunks = 0